export function OutlineSelectSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0015 6.99805V5.77405C21.0015 4.79485 20.1999 3.99805 19.2255 3.99805H18.0015"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M18.0015 20.0017H19.2207C19.7103 20.0017 20.1519 19.8001 20.4735 19.4785"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M4.99854 17.002V18.226C4.99854 19.2052 5.80014 20.002 6.77454 20.002H7.99854"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M4.99854 6.99739V5.77819C4.99854 5.28859 5.20014 4.84699 5.52174 4.52539"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M17.2 9L16.1008 10.0992"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.80005 12.5996L11.2 14.9996L13.6 12.5996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.99854 9.99805V14.0012" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M10.9985 20.002H15.0017" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M15.0017 4.00285L10.9985 3.99805" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M20.9968 14.0012L21.0016 9.99805" stroke={stroke} strokeWidth={strokeWidth} />
      <path
        d="M4 3L22 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
